<script setup lang="ts">
const props = defineProps({
  color: {
    type: String,
    default: '#ff5044',
  },
})
</script>
<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.7975 13.3832L8.70711 10.2929C8.31658 9.90237 7.68342 9.90237 7.29289 10.2929C6.90237 10.6834 6.90237 11.3166 7.29289 11.7071L11.0902 15.5044C11.4807 15.8949 12.1138 15.895 12.5043 15.5046L16.2438 11.7663C16.6344 11.3759 16.6345 10.7427 16.244 10.3521C15.8536 9.96152 15.2204 9.96142 14.8298 10.3519L11.7975 13.3832Z"
      :fill="props.color"
    />
  </svg>
</template>
